import { Text, View } from 'react-native'
import { colors } from '@/src/theme'
import { label1Tight, label3 } from '@/src/theme/typography'
import { useTranslation } from 'react-i18next'

import {
  VOICE_ASSESSMENT_ANALYZING_TITLE_LINE_HEIGHT,
  VOICE_ASSESSMENT_FIGMA_GAP,
} from '../../constants/statistics.styles'
import { VoiceAssessmentAnalyzingBorderShell } from './VoiceAssessmentAnalyzingBorderShell'

interface VoiceAssessmentLatestAnalyzingCardProps {
  dateLabel: string
  isLatest?: boolean
}

export function VoiceAssessmentLatestAnalyzingCard({
  dateLabel,
  isLatest = true,
}: VoiceAssessmentLatestAnalyzingCardProps) {
  const { t } = useTranslation(['statistics'])

  return (
    <VoiceAssessmentAnalyzingBorderShell
      style={{ marginBottom: VOICE_ASSESSMENT_FIGMA_GAP }}
    >
      <View className="gap-1">
        {isLatest ? (
          <>
            <Text
              style={[
                label1Tight,
                {
                  color: colors.textHeader,
                  lineHeight: VOICE_ASSESSMENT_ANALYZING_TITLE_LINE_HEIGHT,
                },
              ]}
            >
              {t('statistics:voice_assessment_analyzing_title')}
            </Text>
            <Text style={[label3, { color: colors.textBody }]}>
              {dateLabel}
            </Text>
          </>
        ) : (
          <>
            <Text
              style={[
                label1Tight,
                {
                  color: colors.textHeader,
                  lineHeight: VOICE_ASSESSMENT_ANALYZING_TITLE_LINE_HEIGHT,
                },
              ]}
            >
              {dateLabel}
            </Text>
            <Text style={[label3, { color: colors.textBody }]}>
              {t('statistics:voice_assessment_history_row_analyzing')}
            </Text>
          </>
        )}
      </View>
    </VoiceAssessmentAnalyzingBorderShell>
  )
}
